import { each, go, isNil, mapL, rejectL } from "fxjs/es";
import { CommonNS } from "../../../../Common/CommonNS.js";
import { VONS } from "../../VO/VONS.js";
import { TransformManipulator } from "./TransformManipulator.js";
export class RotateTransforming {
  constructor({ svg_el, transform_manipulator }) {
    this._observer_set = new Set();
    this._svg_el = svg_el;
    this._transform_manipulator = transform_manipulator;
    this._transforming_els = [];
    this._is_started = false;
    this._start_x1 = 0;
    this._start_y1 = 0;
    this._start_x2 = 0;
    this._start_y2 = 0;
    this._origin_x = 0;
    this._origin_y = 0;
  }
  subscribe(observer) {
    if (this._observer_set.has(observer)) {
      throw new Error(`이미 등록된 observer 입니다.`);
    }
    this._observer_set.add(observer);
    return () => {
      this._observer_set.delete(observer);
    };
  }
  start({ x1, y1, x2, y2, origin_x, origin_y, els }) {
    if (this._is_started) {
      return;
      // throw new Error(`이미 진행중인 rotate_transform 이 있습니다.`);
    }

    if (els.length <= 0) {
      return;
    }
    each((el) => {
      this._transform_manipulator.initTransform(el);
      this._transform_manipulator.setExtendedTransformAfterBase(
        this._svg_el.createSVGMatrix(),
        el
      );
      el.dispatchEvent(
        new CustomEvent(`@mp/sticker-editor/transform`, {
          bubbles: true,
          cancelable: true,
          composed: false,
          detail: {
            el,
            transform_type: "rotate",
            transform_status: "start",
          },
        })
      );
    })(els);
    this._transforming_els = els;
    this._is_started = true;
    this._start_x1 = x1;
    this._start_y1 = y1;
    this._start_x2 = x2;
    this._start_y2 = y2;
    this._origin_x = origin_x;
    this._origin_y = origin_y;
    this._notify({
      status: "START",
      matrix: this._svg_el.createSVGMatrix(),
    });
  }
  progress({ x1, y1, x2, y2 }) {
    if (!this._is_started) {
      throw new Error(`rotate_transform 이 진행중이 아닙니다.`);
    }
    const angle1 =
      (Math.atan2(
        this._start_y2 - this._start_y1,
        this._start_x2 - this._start_x1
      ) *
        180) /
      Math.PI;
    const angle2 = (Math.atan2(y2 - y1, x2 - x1) * 180) / Math.PI;
    const angle = angle2 - angle1;
    const rotate_transform = this._svg_el.createSVGTransform();
    rotate_transform.setRotate(angle, this._origin_x, this._origin_y);
    const { matrix } = rotate_transform;
    go(
      this._transforming_els,
      mapL((el) => ({
        el,
        el_ctm: el.getCTM(),
      })),
      rejectL(({ el_ctm }) => isNil(el_ctm)),
      mapL(({ el, el_ctm }) => {
        const el_consolidated_transform_matrix =
          CommonNS.UtilNS.getConsolidatedTransformMatrix(el) ??
          this._svg_el.createSVGMatrix();
        return {
          el,
          el_ctm,
          el_consolidated_transform_matrix,
        };
      }),
      mapL(({ el, el_ctm, el_consolidated_transform_matrix }) => ({
        el,
        el_transform_matrix: el_consolidated_transform_matrix
          .multiply(el_ctm.inverse())
          .multiply(matrix)
          .multiply(el_ctm)
          .multiply(el_consolidated_transform_matrix.inverse()),
      })),
      each(({ el, el_transform_matrix }) => {
        this._transform_manipulator.setExtendedTransformAfterBase(
          el_transform_matrix,
          el
        );
        el.dispatchEvent(
          new CustomEvent(`@mp/sticker-editor/transform`, {
            bubbles: true,
            cancelable: true,
            composed: false,
            detail: {
              el,
              transform_type: "rotate",
              transform_status: "progress",
            },
          })
        );
      })
    );
    this._notify({
      status: "PROGRESS",
      matrix: matrix,
    });
  }
  end() {
    if (!this._is_started) {
      throw new Error(`rotate_transform 이 진행중이 아닙니다.`);
    }
    each((el) => {
      this._transform_manipulator.mergeExtendedTransformToBase(el);
      el.dispatchEvent(
        new CustomEvent(`@mp/sticker-editor/transform`, {
          bubbles: true,
          cancelable: true,
          composed: false,
          detail: {
            el,
            transform_type: "rotate",
            transform_status: "end",
          },
        })
      );
    })(this._transforming_els);
    this._transforming_els = [];
    this._is_started = false;
    this._start_x1 = 0;
    this._start_y1 = 0;
    this._start_x2 = 0;
    this._start_y2 = 0;
    this._origin_x = 0;
    this._origin_y = 0;
    this._notify({
      status: "END",
      matrix: this._svg_el.createSVGMatrix(),
    });
  }
  _notify(selection_transform_vo) {
    for (const observer of this._observer_set) {
      CommonNS.UtilNS.tryNoop(() => observer(selection_transform_vo));
    }
  }
}
